var COS = require('cos-js-sdk-v5')
import { Message } from 'element-ui'
var url = window.location.href
var start = url.indexOf('#/') + 2
var end = url.indexOf('/index')
var result = url.substring(start, end)
console.log(result)

// 随机生成的数字
// function generateUniqueString() {
//   const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
//   const currentDate = new Date().toISOString().slice(0, 10).replace(/-/g, '')
//   const timestamp = Date.now().toString()
//   let randomString = ''
//   for (let i = 0; i < 5; i++) {
//     randomString += letters.charAt(Math.floor(Math.random() * letters.length))
//   }
//   return randomString + currentDate + timestamp
// }
function generateUniqueString() {
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  const currentDate = new Date().toISOString().slice(0, 10).replace(/-/g, '')
  const timestamp = Date.now().toString()
  let randomString = ''
  for (let i = 0; i < 5; i++) {
    randomString += letters.charAt(Math.floor(Math.random() * letters.length))
  }
  return randomString + currentDate + timestamp
}
export function uploadFilesimg(files, progressEvent, name, config) {
  // console.log('name:', name)
  // console.log('config:===============', config)
  // const fig = config.replace('domain=', '')
  // const domain = config.domain// fig.match(/^(https?:\/\/[^\/]+)/)[1]
  const SecretId = config.secret_id// fig.match(/secret_id=([^&]+)/)[1]
  const SecretKey = config.secret_key// fig.match(/secret_key=([^&]+)/)[1]
  const bucket = config.bucket// fig.match(/bucket=([^&]+)/)[1]
  const region = config.region// fig.match(/region=([^&]+)/)[1]
  const cos = new COS({
    SecretId, // 推荐使用环境变量获取；用户的 SecretId，建议使用子账号密钥，授权遵循最小权限指引，降低使用风险。子账号密钥获取可参考https://cloud.tencent.com/document/product/598/37140
    SecretKey// 推荐使用环境变量获取；用户的 SecretKey，建议使用子账号密钥，授权遵循最小权限指引，降低使用风险。子账号密钥获取可参考https://cloud.tencent.com/document/product/598/37140
  })
  // console.log(domain)
  // console.log(SecretId)
  // console.log(SecretKey)
  // console.log(bucket)
  // console.log(region)

  const uniqueString = generateUniqueString()

  // console.log('name:', name)
  // console.log('=======================', files.name)
  let extension = ''
  if (files.name) {
    extension = files.name.substring(files.name.lastIndexOf('.') + 1)
  }
  // const size = files.size
  // if (size === 4) {
  // 获取文件名的后缀
  const fileExtension = files.name.split('.').pop().toLowerCase()
  let filePath = ''
  if (['mp4', 'mov'].includes(fileExtension)) {
    filePath = `/dj/video/${name}/newlyinmessage/${name}${uniqueString}.${extension}`
    // filePath = `/video/${name}/` + files.name
  } else if (['jpeg', 'jpg', 'png', 'gif'].includes(fileExtension)) {
    // filePath = `/img/${name}/` + files.name
    filePath = `/dj/img/${name}/newlyinmessage/${name}${uniqueString}.${extension}`
  }
  // console.log('filePath:', filePath)
  // 使用 filePath 进行后续操作，例如上传文件或其他处理
  // ...
  var fileList = [files].map(file => ({
    Bucket: bucket, /* 填入您自己的存储桶，必须字段 */
    Region: region, /* 存储桶所在地域，例如 ap-beijing，必须字段 */
    Key: filePath, /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
    // Key: file.name, /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
    Body: file
  }))

  return new Promise((resolve, reject) => {
    cos.uploadFiles({
      files: fileList,
      SliceSize: 1024 * 1024 * 5, /* 触发分块上传的阈值，超过5MB使用分块上传，非必须 */
      onProgress: function(progressData) {
        // console.log(JSON.stringify(progressData), '4444444--')
        const num = progressData.loaded / progressData.total * 100 | 0 // 百分比
        progressEvent(num)
      },
      onFileFinish: function(err, data, options) {
        // console.log(options.Key + '上传' + (err ? '失败' : '成功'))
        err ? Message('上传失败') : Message.success('上传成功')
      }
    }, function(err, data) {
      if (err) {
        reject(err)
      } else {
        // -------------------------------------截视频封面---------------------------------
        // data.files[0].options.Key = domain + '/' + data.files[0].options.Key
        console.log('data+++++++++++++++++++++:', data.files[0].options.Key)
        resolve(data)
      }
    })
  })
}

// export function uploadHtmlFile(file, htmlNo, progressEvent, config) {
//   const { secret_id, secret_key, bucket, region } = config

//   const cos = new COS({
//     SecretId: secret_id,
//     SecretKey: secret_key
//   })

//   const filePath = `/dj/html/${htmlNo}.html`

//   const fileList = [{
//     Bucket: bucket,
//     Region: region,
//     Key: filePath,
//     Body: file
//   }]

//   return new Promise((resolve, reject) => {
//     cos.uploadFiles({
//       files: fileList,
//       SliceSize: 1024 * 1024 * 5,
//       onProgress: function (progressData) {
//         const percent = Math.floor(progressData.loaded / progressData.total * 100)
//         progressEvent(percent)
//       },
//       onFileFinish: function (err, data) {
//         if (err) Message.error('HTML 上传失败')
//         else Message.success('HTML 上传成功')
//       }
//     }, function (err, data) {
//       if (err) reject(err)
//       else resolve(data)
//     })
//   })
// }

/**
 * 包装 HTML 内容为完整文档结构，避免乱码
 * @param {string} content - 原始 HTML 片段
 * @returns {string} 包装后的完整 HTML 文本
 */
function wrapHtmlContent(content, title) {
  return `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <title>${title}</title>
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <style>
  html, body {
    margin: 0 auto !important;
    padding: 0;
    width: 680px !important;
    overflow-x: hidden;
  }
  img, video, iframe {
      max-width: 680px !important;
      height: auto;
  }
  * {
    box-sizing: border-box;
  }
  @media (max-width: 480px) {
    html, body{
     width:100% !important;
    max-width: 100vw !important;
     }
    img, video, iframe {
    max-width: 100% !important;
    height: auto;
     }
    }
</style>
</head>
<body>
  ${content}
</body>
</html>`
}

/**
 * 上传 HTML 文本到腾讯云 COS
 * @param {string} htmlText - 原始 HTML 内容（可能是不完整结构）
 * @param {string} htmlNo - 文件名标识
 * @param {function} progressEvent - 上传进度百分比回调
 * @param {object} config - 腾讯云配置对象
 * @returns {Promise<{ fileKey: string, fileUrl: string }>}
 */
export function uploadHtmlFile(htmlText, htmlNo, progressEvent, config, title, created_at_date) {
  const { secret_id, secret_key, bucket, region, domain } = config

  const cos = new COS({
    SecretId: secret_id,
    SecretKey: secret_key
  })

  // ✅ 包装成完整 HTML 文档结构
  const finalHtml = wrapHtmlContent(htmlText, title)

  // ✅ 生成 Blob/File
  const blob = new Blob([finalHtml], { type: 'text/html;charset=utf-8' })
  const file = new File([blob], `${htmlNo}.html`, { type: 'text/html;charset=utf-8' })

  // ✅ 固定文件路径
  const filePath = `msg_html/${created_at_date}/${htmlNo}.html`

  const fileList = [{
    Bucket: bucket,
    Region: region,
    Key: filePath,
    Body: file
  }]

  return new Promise((resolve, reject) => {
    cos.uploadFiles({
      files: fileList,
      SliceSize: 1024 * 1024 * 5,
      onProgress(progressData) {
        const percent = Math.floor(progressData.loaded / progressData.total * 100)
        progressEvent(percent)
      },
      onFileFinish(err) {
        if (err) {
          Message.error('HTML 上传失败')
        } else {
          // Message.success('HTML 上传成功')
        }
      }
    }, (err, data) => {
      if (err) {
        reject(err)
      } else {
        resolve({
          fileKey: filePath,
          fileUrl: domain + filePath
        })
      }
    })
  })
}
/**
 * 上传 HTML 文本文件到腾讯云 COS
 * @param {string} htmlText - 后端返回的完整 HTML 内容（不可更改）
 * @param {string} htmlNo - 文件名标识（不含扩展名）
 * @param {function} progressEvent - 上传进度回调函数（传入百分比）
 * @param {object} config - 包含 secret_id、secret_key、bucket、region、domain 的配置对象
 * @param {string} title - 页面标题（不用于处理，仅保留参数结构）
 * @returns {Promise<{ fileKey: string, fileUrl: string }>}
 */
export function uploadHtmlFiletwo(htmlText, htmlNo, progressEvent, config, title, created_at_date) {
  const { secret_id, secret_key, bucket, region, domain } = config

  const cos = new COS({
    SecretId: secret_id,
    SecretKey: secret_key
  })

  // 将 HTML 文本打包成 .html 文件对象
  const blob = new Blob([htmlText], { type: 'text/html;charset=utf-8' })
  const file = new File([blob], `${htmlNo}.html`, { type: 'text/html;charset=utf-8' })

  const filePath = `msg_html/${created_at_date}/${htmlNo}.html`

  const fileList = [{
    Bucket: bucket,
    Region: region,
    Key: filePath,
    Body: file
  }]

  return new Promise((resolve, reject) => {
    cos.uploadFiles({
      files: fileList,
      SliceSize: 1024 * 1024 * 5,
      onProgress(progressData) {
        const percent = Math.floor(progressData.loaded / progressData.total * 100)
        progressEvent(percent)
      },
      onFileFinish(err) {
        if (err) {
          Message.error('HTML 上传失败')
        } else {
          Message.success('HTML 上传成功')
        }
      }
    }, (err, data) => {
      if (err) {
        reject(err)
      } else {
        resolve({
          fileKey: filePath,
          fileUrl: domain + filePath
        })
      }
    })
  })
}

/**
 * 拼接 HTML 内容
 */
function buildHtmlPage(headContent, bodyContent, scriptContent, title = '') {
  return `<!DOCTYPE html>
<html lang="zh">
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>${title}</title>
  ${headContent}
</head>
<body>
  ${bodyContent}
  ${scriptContent}
</body>
</html>`
}

/**
 * 上传拼接后的 HTML 页面到腾讯云 COS
 * @param {object} htmlParts - 包含 headContent, bodyContent, scriptContent
 * @param {string} htmlNo - 文件名标识
 * @param {function} progressEvent - 上传进度回调
 * @param {object} config - 腾讯云 COS 配置
 * @param {string} title - 页面标题（用于 <title>）
 */
export function uploadHtmlFilepinjie(htmlParts, htmlNo, progressEvent, config, title, created_at_date) {
  const { secret_id, secret_key, bucket, region, domain } = config
  const { headContent, bodyContent, scriptContent } = htmlParts

  const cos = new COS({
    SecretId: secret_id,
    SecretKey: secret_key
  })

  const finalHtml = buildHtmlPage(headContent, bodyContent, scriptContent, title)

  const blob = new Blob([finalHtml], { type: 'text/html;charset=utf-8' })
  const file = new File([blob], `${htmlNo}.html`, { type: 'text/html;charset=utf-8' })

  const filePath = `msg_html/${created_at_date}/${htmlNo}.html`

  const fileList = [{
    Bucket: bucket,
    Region: region,
    Key: filePath,
    Body: file
  }]

  return new Promise((resolve, reject) => {
    cos.uploadFiles({
      files: fileList,
      SliceSize: 5 * 1024 * 1024,
      onProgress(progressData) {
        const percent = Math.floor(progressData.loaded / progressData.total * 100)
        progressEvent(percent)
      },
      onFileFinish(err) {
        if (err) {
          Message.error('HTML 上传失败')
        } else {
          Message.success('HTML 上传成功')
        }
      }
    }, (err, data) => {
      if (err) {
        reject(err)
      } else {
        resolve({
          fileKey: filePath,
          fileUrl: domain + filePath
        })
      }
    })
  })
}

